import type { PropsWithChildren } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsClientReady } from './hooks/use-is-client-ready.tsx';

export type RenderOnClientProps = PropsWithChildren<{ fg?: string }>;

/**
 * Renders children only on the client side.
 *
 * @param children - The children to render.
 * @param fg - The feature gate name.
 */
export const RenderOnClient = ({ children, fg: featureGateName }: RenderOnClientProps) => {
	const isClientReady = useIsClientReady();

	// eslint-disable-next-line jira/ff/static-feature-flags
	if (featureGateName && !fg(featureGateName)) {
		return children;
	}

	if (isClientReady) {
		return children;
	}

	return null;
};
